
import { mapState, mapMutations } from 'vuex';
// import eKwanza from './eKwanza.vue';
import KwanzaRef from './kwanzaRef.vue';
import KwanzaGpo from './kwanzaGpo.vue';
import HiPay from '@/components/shop/hiPay.vue';
import Multibanco from '@/components/shop/multibanco.vue';
import MbWay from '@/components/shop/mbWay.vue';

export default {
  name: 'PaymentMethods',

  components: {
    HiPay,
    Multibanco,
    MbWay,
    // eKwanza,
    KwanzaRef,
    KwanzaGpo,
  },

  data() {
    return {
      multibanco: true,
      mbway: false,
      card: false,
    };
  },

  computed: {
    ...mapState(['user', 'order', 'orderId', 'patientId', 'method']),
  },

  mounted() {
    setTimeout(() => {
      if (this.isSpanish || this.isFrench) {
        this.setMethod('card');
      } else if (this.isAngola) {
        this.setMethod('kwanza-gpo');
      } else {
        this.setMethod('mbway');
      }
    }, 500);
  },

  methods: {
    ...mapMutations(['setMethod']),

    paymentFail(response) {
      const msg = response.reason?.message || response || 'unknown';
      this.$emit('fail', `${this.$t('checkout.paymentFailed')}: ${msg}`);
    },

    paymentSuccess(result) {
      const msg =
        result === 'multibanco'
          ? this.$t('checkout.mb_info')
          : this.$t('checkout.paymentSuccess');

      this.$emit('success', {
        method: result.method,
        msg,
        state: result.state,
      });
    },

    pay() {
      if (this.isSpanish || this.isFrench) {
        this.$refs.hipay.pay();
      } else {
        switch (this.method) {
          case 'card':
            this.$refs.hipay.pay();
            break;
          case 'multibanco':
            this.$refs.mb.pay();
            break;
          case 'mbway':
            this.$refs.mw.pay();
            break;
          case 'e-kwanza':
            this.$refs.eKwanza.pay();
            break;
          case 'kwanza-ref':
            this.$refs.kwanzaRef.pay();
            break;
          case 'kwanza-gpo':
            this.$refs.kwanzaGpo.pay();
            break;
          default:
            this.paymentFail(this.$t('checkout.choose_a_payment_method'));
        }
      }
    },
  },
};
